import { ref, getDownloadURL, uploadBytes } from "firebase/storage";
import { storage } from "../../firebase";
import { updateImage } from "../slices/storageSlice";

export async function getDownloadUrl(path) {
  try {
    return await getDownloadURL(ref(storage, path));
  } catch (error) {
    if (error.code === "storage/object-not-found") {
      return null;
    }
    throw error;
  }
}

export function getImage(path) {
  return async (dispatch, getState) => {
    const state = getState();
    if (!path || state.storage[path]) return;

    try {
      const url = await getDownloadURL(ref(storage, path));
      dispatch(updateImage({ [path]: url }));
    } catch (error) {
      if (error.code === "storage/object-not-found") {
        return;
      }
      console.error("Error getting image:", error);
    }
  };
}

export function upload(path, files, dbPath, options) {
  return async (dispatch) => {
    // Note: react-redux-firebase's uploadFiles did more (like updating firestore).
    // This is a simplified version.
    const promises = Array.from(files).map(async (file) => {
      const storageRef = ref(storage, `${path}/${file.name}`);
      const snapshot = await uploadBytes(storageRef, file);
      const url = await getDownloadURL(snapshot.ref);
      dispatch(updateImage({ [snapshot.ref.fullPath]: url }));
      return { snapshot, url };
    });
    return Promise.all(promises);
  };
}